var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.addonsType.length > 0)?_c('div',{},[_vm._m(0),_vm._l((_vm.addonsType),function(addonType,i){return _c('div',{key:i,staticClass:"d-flex justify-content-between"},[_c('span',[_vm._v(_vm._s(addonType)+":")]),_c('span',[_vm._v(_vm._s(_vm._f("currency")(_vm.getTotalByAddonType(addonType))))])])})],2):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h5"},[_c('i',[_vm._v("Cost per addon type")])])
}]

export { render, staticRenderFns }